<template>
  <div id="result-table">
    <vs-table max-items="100" pagination :data="datas" no-data-text="กำลังรอข้อมูล...">
      <template slot="thead">
        <vs-th width="15%">รอบ</vs-th>
        <vs-th width="15%">วันที่</vs-th>
        <vs-th width="15%">เวลาปิดหวย</vs-th>
        <vs-th width="15%">เริ่มหมุน</vs-th>
        <vs-th width="15%">แสดงผล</vs-th>
        <vs-th width="15%">ผล</vs-th>
        <vs-th width="10%"></vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ tr.round }}
          </vs-td>
          <vs-td>
            {{ tr.lotto_date }}
          </vs-td>
          <vs-td>
            {{ startTime(tr.close_date) }}
          </vs-td>
          <vs-td>
            {{ startTime(tr.start_spin) }}
          </vs-td>
          <vs-td>
            {{ startTime(tr.show_result) }}
          </vs-td>
          <vs-td>
            <strong style="color: blue">{{ tr.result | showResult }}</strong>
          </vs-td>
          <vs-td>
            <vs-button class="float-right" color="success" icon-pack="feather" icon="icon-edit" @click="editData(tr)">แก้ไข</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import LottoService from "@/services/lottoService"

import moment from "moment"

export default {
  data() {
    return {
      results: []
    }
  },
  computed: {
    datas() {
      return this.results
    }
  },
  methods: {
    loadResults() {
      LottoService.getResults(this.$route.params.resultDate).then((response) => {
        if(response.status === 'success') {
          this.results = response.datas
        }
      })
    },
    deleteData(id) {
      if (confirm('ต้องการลบ?')) {
        LottoService.deleteResult(id).then((response) => {
          if (response.result === 'success') {
            this.loadResults()
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'ลบข้อมูลเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'ลบข้อมูลไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        })
      }
    },
    editData(round) {
      //console.log(id)
      this.$router.push({ name: 'admin-edit-results', params: { resultDate: round.lotto_date, resultId: round.round_id } })
    },
    startTime(datetime) {
      if (datetime) {
        return moment(datetime).format("HH:mm")
      } else {
        return '-'
      }
    }
  },
  created() {
    this.loadResults()
  },
  filters: {
    showResult(val) {
      if(val) {
        let result = val
        return result.number
      }else{
        return '-'
      }
    }
  }
}
</script>
<style lang="scss">
#result-table {
  button.vs-button {
    padding: 0.5rem 1rem !important;
  }
}

</style>
